import { Injectable } from '@angular/core';
import { WinnerApiService } from '@fantaz/shared/data-access/api';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import { catchError, map, of, switchMap } from 'rxjs';

import * as PrizesActions from './prizes.actions';
import * as PrizesFeature from './prizes.reducer';

@Injectable()
export class PrizesEffects {
  init$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PrizesActions.init),
        switchMap(({ params }) => {
          return this.winnerService.getPrizesWon(params).pipe(
            map((prizes) => {
              return PrizesActions.loadPrizesSuccess({ prizes });
            }),
            catchError((error) => {
              return of(PrizesActions.loadPrizesFailure({ error }));
            }),
          );
        }),
      ),
    { dispatch: true },
  );

  constructor(
    private readonly actions$: Actions,
    private readonly winnerService: WinnerApiService,
  ) {}
}
